import {
  IconWrapper,
  ImageWrapper,
  InputFieldContainer,
  IStyles,
  PrimaryButton,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import { Box, Button, Modal, Slide, SxProps } from '@mui/material';
import { useDownloadContext } from '../../../../../app/Context/DownloadContextProviderV2';
import { interactionEvent } from '../../../../Auth/auth.events';
import { ReactNode, useState } from 'react';
import { useLocation } from 'react-router-dom';

const styles: IStyles = {
  root: {},
  iconBox: {
    height: { xs: pxToRem(113), md: pxTovW(143) },
    display: 'flex',
    width: { xs: pxToRem(113), md: pxTovW(143) },
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    transform: 'translateY(-50%)',
  },
  actionPopupText: {
    margin: {
      xs: '30% auto 20px auto',
      md: `auto auto ${pxTovW(20)} auto`,
    },
    textAlign: 'center',
    //   alignSelf: 'flex-end',
    height: 'max-content',
    width: { xs: '90%', md: pxTovW(388) },
  },
  actionPopupTextSmall: {
    margin: {
      xs: `${pxToRem(60)} auto 0 auto`,
      md: `${pxTovW(92)} auto 0 auto`,
    },
    textAlign: 'center',
    //   alignSelf: 'flex-end',
    height: '100%',
    width: { xs: '90%', md: pxTovW(388) },
  },
};

interface IProps {
  open: boolean;
  handleClose: () => void;
  saveTemplateHandler: (templateName: string) => void;
}
export const SaveTemplatePopup = (props: IProps) => {
  const { open, handleClose, saveTemplateHandler } = props;
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();

  const [templateName, setTemplateName] = useState<string>('');
  return (
    <Modal
      open={open}
      onClose={() => {
        setTemplateName('');
        handleClose();
      }}
    >
      <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={500}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              // mt: { xs: '18%', md: '10%' },
              gap: { xs: pxToRem(30), md: pxTovW(20) },
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'center', md: 'flex-start' },
              width: { xs: '95%', md: 'unset' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'white',
                width: { xs: '65%', md: pxTovW(600) },
                borderRadius: { xs: pxToRem(20), md: pxTovW(20) },
                // height: { xs: pxToRem(220), md: pxTovW(300) },
                padding: { xs: pxToRem(20), md: pxTovW(40) },
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  top: { xs: pxToRem(-15), md: pxTovW(-18) },
                  left: '0%',
                  height: { xs: pxToRem(15), md: pxTovW(18) },
                  width: '100%',
                }}
              >
                <IconBox iconName="layout" />
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: { xs: pxToRem(10), md: pxTovW(20) },
                  marginTop: { xs: pxToRem(40), md: pxTovW(40) },
                  width: '100%',
                }}
              >
                <InputFieldContainer
                  topLabel="Template Name"
                  value={templateName}
                  helperTextvariant="error"
                  onChange={(e) => setTemplateName(e.target.value.trimStart())}
                  onEnter={async () => {
                    if (templateName) {
                      saveTemplateHandler(templateName.trim());
                      setTemplateName('');
                      handleClose();
                    }
                  }}
                  type="text"
                  rootSx={{
                    width: '100%',
                  }}
                />
                <PrimaryButton
                  variant="contained"
                  sx={{
                    width: { xs: '90%', md: '50%' },
                    marginTop: { xs: pxToRem(10), md: pxTovW(20) },
                  }}
                  disabled={!templateName}
                  onClick={async () => {
                    saveTemplateHandler(templateName.trim());
                    setTemplateName('');
                    handleClose();
                    await interactionEvent({
                      context: 'Template_name',
                      name: 'SUBMIT',
                      pathSegments: pathSegments,
                      isOffline: isOffline,
                    });
                  }}
                >
                  SUBMIT
                </PrimaryButton>
              </Box>
            </Box>

            <Button
              onClick={() => {
                setTemplateName('');
                handleClose();
              }}
              sx={{ p: '0px' }}
            >
              <IconWrapper
                name="close-yellow"
                size="md"
                parentFolder="icons"
                type="png"
                customSx={{
                  width: { xs: pxToRem(33), md: pxTovW(54) },
                  height: { xs: pxToRem(33), md: pxTovW(54) },
                }}
              />
            </Button>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};
interface IConProps {
  iconName: string;
}
const IconBox = (props: IConProps) => {
  const { iconName } = props;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={styles.iconBox}>
        <ImageWrapper
          name={iconName}
          parentFolder="icons"
          type="png"
          styles={{
            height: { xs: pxToRem(52), md: pxTovW(60) },
            width: { xs: pxToRem(52), md: pxTovW(60) },
          }}
        />
      </Box>
    </Box>
  );
};
